import { render, staticRenderFns } from "./goalLink.vue?vue&type=template&id=c56a1596&"
import script from "./goalLink.vue?vue&type=script&lang=js&"
export * from "./goalLink.vue?vue&type=script&lang=js&"
import style0 from "./goalLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules_dev/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports